import { EventCategory, FilterInput, FilterOperator } from '@kinetic-ui/data-layer';

const roadConditionFilter = {
  value: EventCategory.RoadCondition,
  operator: FilterOperator.Equals,
  field: 'category',
};

export const filterRoadConditions = (additionalFilters?: FilterInput[]) => {
  return [roadConditionFilter, ...(additionalFilters ?? [])];
};
